module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("about")])]), _c('br'), _vm._v("CLEANSING")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sidebar"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A juice cleanse generally refers to a meal plan where whole foods are replaced by nutrient-dense juices up to 5 times a day. Such cleanses are touted as ways to give the digestive system a break, recharge your body with an influx of vitamins and minerals, and, sometimes, to lose weight. If you’re thinking about cleansing, it’s important to first consult your doctor or a nutritionist and map out a plan that’s best suited to your health needs and personal goals. Juice cleansing isn’t for everyone, especially young children and pregnant women, and there’s no guarantee of health gain or weight loss results. If you’re looking to begin a low-risk cleanse, start by replacing one meal or snack a day with a juice. Make sure to include a variety of soft and hard vegetables and fruit to ensure you’re getting a balanced meal in place of your solid one.")])]), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("Why, When & How to Juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Why")])]), _vm._v(" There are endless reasons to juice: to improve health, increase energy, lose weight, prevent diseases, and more. While we can’t guarantee any of these results, we can say that incorporating juices into your everyday life is a positive step for your wellbeing. Adding just one juice in the morning supplies more nutrients than some people consume in a whole a day. In addition, juicing provides a simplified way of preparing and consuming all your favorite produce. It’s a healthy, refreshing, and fast way to fulfill your body’s dietary needs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("When")])]), _vm._v(" Deciding when to juice is up to you. Since juicing is a great way to deliver a nutrient boost, incorporating a juice into your breakfast plan is a smart start and can boost your energy without the aid of caffeine. If you want a quick, easy, and healthy meal-on- the go, there are lots of juices that are bolstered with healthy fats and fiber to keep you satisfied. If you’re preparing for a mentally or physically challenging activity, like travel, an important exam, or a sports competition, there are juices to help build your immune system. If you’ve overindulged in food or alcohol, there are juices to help flush toxins out of your system. Over time, you’ll grow to enjoy these juices so much, you’ll drink them just because you feel like it!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("How")])]), _vm._v(" Juicing requires a certain level of commitment, but the long-term payoff for your health is well worth it. First, you’ll need to invest in a juicer. We’ve created a chart on pages 12—13 to help you pick a home juicer that’s right for you. Next, in order to get the most out of your juicer, it’s helpful to maintain a fresh supply of fruits and vegetables. Having an abundance and variety of produce on hand means fulfilling any craving or health need in seconds. If you have a busy schedule, you may find juicing easier and even more enjoyable when you have an abundance of juices within arm’s reach. Most juices will stay fresh for up to 3 days in the refrigerator, or for longer in the freezer, so you can plan ahead if you have a busy schedule. (Frozen juices need a few hours in the refrigerator to thaw.) Finally, start experimenting! By mixing and matching ingredients, you’ll soon learn what tastes and feels good to you.")])]), _c('h1', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Choosing a Juicer")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Buying a juicer can be confusing—there are many different models on the market, each touting different features and benefits. This guide differentiates between the two most popular juicer models: a slow-masticating juicer and a centrifugal juicer. Below we explain the difference between these types of juicers and the pros and cons of each, to help you decide which model is best suited to your juicing needs.")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Slow-Masticating Juicer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A two-stage, low-speed system first crushes the food, and then presses it to ensure a high juice yield without aerating the juice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FEATURES AND BENEFITS:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The juicing process takes a few seconds longer than with a centrifugal juicer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Produces less heat than a centrifugal juicer, therefore preserving more natural enzymes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For the highest juice yield, cut ingredients into 2-inch (5-cm) pieces")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Many models let you customize the amount of pulp and fiber in your juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Slow operating speed reduces chance of oxidation (when juice loses some of its natural color) and separation (froth on top and layering of juice ingredients)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Delivers 35% more juice and maintains up to 60% more vitamins from certain types of fresh produce, such as herbs and leafy greens, than traditional centrifugal models")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Some models make smoothies as well as juice")])]), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('h1', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Centrifugal Juicer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A fast spinning motion shreds ingredients into a pulp, and then extracts the juice from the pulp with centrifugal force.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FEATURES AND BENEFITS:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Juice is extracted almost instantly, which is helpful for a busy schedule")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Models with a wide feeding tube mean many ingredients don’t need to be pre-cut")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Some models boast two speeds: low for softer ingredients, high for firmer ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("High operating speed means some oxidation (when juice loses some of its natural color) and separation (froth on top and layering of juice ingredients) can occur")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Extracts the most juice from soft, high-moisture ingredients and extracts less juice from fibrous and leafy ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Centrifugal models are generally more affordable than slow-masticating models")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-831ee45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap02.vue
// module id = 75
// module chunks = 0